import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Notification.css';
import axios from 'axios';
import { 
    QuestionCircleFill,
    ExclamationTriangleFill,
    XCircle,
    InfoCircle,
    CheckCircle,
    EnvelopeFill
} from 'react-bootstrap-icons';

export default function SingleNotification({notifId = 'no uuid', notifPath = '/', notifHeader, notifBody = 'This is the body of your notification', notifIcon = <QuestionCircleFill/>}){
    const navigate = useNavigate();
    const [userId, setUserId] = useState('');
    const userIdRef = useRef('');

    const [displayBody, setBody] = useState(notifBody);
    const [pathLastname, setPathLastname] = useState('');

    useEffect(() => {
        axios.post('https://docuquest-swu.swucite.tech/api_drts/checkSession.php', {}, { withCredentials: true })
        .then((res) => {
          // console.warn("is the session alive in singlerequest? ", res.data);
          if (res.data.status === 1) {
            setUserId(res.data.id);
            userIdRef.current = res.data.id;
          } 
        })
        .catch((err) => {
          //console.error("ERROR: Your session cannot be found!", err);
  
        });

    }, []);

    function doMore(path) {
        let pathReference = getReference(path);
    
        axios.get(`https://docuquest-swu.swucite.tech/api_drts/transactionsNotifications.php/${pathReference}`)
            .then((response) => {
                //console.log("API Response:", response.data);
    
                if (response.data && response.data.length > 0) {
                    let ownerLastName = response.data[0].lastname_owner;
                    setPathLastname(ownerLastName); // for later use
    
                    const newPath = getPath(path, notifBody);
                    
                    updateResponded(notifId);

                    // console.log("owner's ref number:", pathReference);
                    // console.log("owner's last name:", ownerLastName);
    
                    if (newPath) {
                        navigate(newPath, { state: { lastname: ownerLastName } });
                    } else {
                        //console.error("Invalid path returned by getPath");
                    }
                } else {
                    //console.warn("No transactions found for reference:", pathReference);
                    setPathLastname('');
                }
            })
            .catch((error) => {
                //console.error("Error fetching transaction data:", error);
                setPathLastname('');
            });
    }

    const updateResponded = (txtId) => {
      if (!txtId || typeof txtId !== "string") return;
    
      //console.log("notification id", txtId);
      const userId = userIdRef.current;
     
      axios
      .get(`https://docuquest-swu.swucite.tech/api_drts/userNotifications.php/${userId}`)
      .then((res) => {
        if (!res.data || res.data.status === 0 || (Array.isArray(res.data) && res.data.length === 0)) {
            //console.warn(`No new notifications for user ${userId}. Skipping update.`);
            return; // Exit if no notifications exist
        }

        //console.warn(`this is a real user. updating responded value...`);
        //console.log(`get notif by user response ${res.data}`)

        axios
        .patch(`https://docuquest-swu.swucite.tech/api_drts/userNotifications.php`, {
            responded: 1,
            notif_id: txtId,
            user_id: userId,
            // type: '',
            // message: '',
        })
        .then((res) => {
            //console.warn(`Updated responded? ${res.data}`);

        })
        .catch((err) => {
          //console.error(`update notif responded ERROR: ${err}`);
        })
      })
      .catch((err) => {
        //console.error(`get notif by user ERROR: ${err}`);
      })
    }

    const getReference = (txtPath) => {
      if (!txtPath || typeof txtPath !== "string") return;

      //console.warn("txtPath", txtPath);

      switch(true){
        case txtPath.includes('respond'):
            // Extract REF-XXXXXXXXXXXX-XXXXXX pattern from notifBody
            const refMatch = notifBody.match(/REF-\d{6,}-\d{4,}/);
            // console.log("got this ref from notifBody:", refMatch[0]);

            if (refMatch) {
                return `${refMatch[0]}`;
            }
            break;

        default:
            //console.error("invalid path!");
            return null;
      }
    }

    // build onclick path based on type of notification
    const getPath = (txtPath, notifBody) => {
      if (!txtPath || typeof txtPath !== "string") return;
        
      //console.warn("txtPath", txtPath);
      //console.warn("notifBody", notifBody);

      switch(true){
          case txtPath.includes('respond'):
            // Extract REF-XXXXXXXXXXXX-XXXXXX pattern from notifBody
            const refMatch = notifBody.match(/REF-\d{6,}-\d{4,}/);
            // console.log("ref match in notifBody:", refMatch);

            if (refMatch) {
                // console.warn("returned path", `respond/${refMatch[0]}`)
                return `respond/${refMatch[0]}`;
            }
            break;

          case txtPath.includes('profile'):
            // Extract user ID after 'profile/' (assuming number at end)
            const profileMatch = notifBody.match(/profile\/(\d+)/);
            if (profileMatch) {
                return `profile/${profileMatch[1]}`;
            }
            break;

        default:
            //console.error("invalid path!");
            return null;
      }
 
    }

    const getIcon = (txtType) => {
      if (!txtType || typeof txtType !== "string") return <QuestionCircleFill />;

      switch(txtType.toLowerCase()){
        case 'info':
            return <InfoCircle/>;
        case 'message':
            return <EnvelopeFill/>;
        case 'alert':
            return <ExclamationTriangleFill/>;
        case 'warning':
            return <ExclamationTriangleFill/>;
        case 'success':
            return <CheckCircle/>;
        case 'error':
            return <XCircle/>;
        default:
            return <QuestionCircleFill/>;
      }
    }

    const capitalizeFirstLetter = (str) => {
        return str ? str.charAt(0).toUpperCase() + str.slice(1) : '';
    };

    return (
        // TODO getpath on onclick
        <div onClick={() => doMore(`${notifPath}`)} title={notifHeader} className='item notification'>
            <section className="notification-content">
              <section className='top'>
                <div className='icon'>{getIcon(notifHeader)}</div>
                <p className='header'>{capitalizeFirstLetter(notifHeader)}</p>
              </section>
            {/* {
             console.warn("notifId ", notifId )
            } */}
              <p className='body'>{displayBody}</p>
            </section>
        </div>
    )
}